"use strict";
/**
 * Created by rouven on 22.03.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
// @ts-ignore
var query_string_1 = __importDefault(require("query-string"));
var actions_1 = require("../../actions");
var ConnectedGridComponent_1 = __importDefault(require("./ConnectedGridComponent"));
var react_router_dom_1 = require("react-router-dom");
var mapStateToProps = function (state, _a) {
    var grid = _a.grid, baseUrl = _a.baseUrl;
    var url = baseUrl;
    var activeSort = null;
    if (state.grid[grid]) {
        var append = {};
        if (state.grid[grid].filter) {
            for (var filter in state.grid[grid].filter) {
                append['filter[' + filter + ']'] = state.grid[grid].filter[filter];
            }
        }
        var pagination = state.grid[grid].pagination;
        if (pagination && pagination.pageSize) {
            append['per-page'] = pagination.pageSize;
        }
        if (pagination && pagination.currentPage) {
            append['page'] = pagination.currentPage;
        }
        if (state.grid[grid].sort) {
            activeSort = state.grid[grid].sort;
            append['sort'] = state.grid[grid].sort;
        }
        if (Object.keys(append).length > 0) {
            var seperator = url.indexOf('?') !== -1 ? '&' : '?';
            url += seperator + query_string_1["default"].stringify(append);
        }
    }
    return {
        url: url,
        activeSort: activeSort
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var grid = _a.grid, replace = _a.replace, location = _a.location;
    return ({
        // @ts-ignore
        handleSort: function (idx, asc) { return dispatch((0, actions_1.changeSort)(grid, idx, asc)(replace, location)); }
    });
};
// @ts-ignore
var ConnectedGrid = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(ConnectedGridComponent_1["default"]);
var ConnectedGridWrapper = function (_a) {
    var _b = _a.force, force = _b === void 0 ? true : _b, rest = __rest(_a, ["force"]);
    var replace = (0, react_router_dom_1.useHistory)().replace;
    var location = (0, react_router_dom_1.useLocation)();
    // @ts-ignore
    return react_1["default"].createElement(ConnectedGrid, __assign({ replace: replace, location: location, force: force }, rest));
};
exports["default"] = ConnectedGridWrapper;
